import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => {
  const spacing = (val, ...args) => {
    if (typeof theme.spacing === 'function') return theme.spacing(val, ...args)
    return (val * 8) + 'px'
  }
  const palette = theme.palette || { background: { paper: '#fff' } }

  return {
    icon: {
      marginRight: spacing(2)
    },
    heroContent: {
      backgroundColor: palette.background.paper,
      padding: spacing(8, 0, 6)
    },
    heroButtons: {
      marginTop: spacing(4)
    },
    cardGrid: {
      paddingTop: spacing(8),
      paddingBottom: spacing(8)
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    cardMedia: {
      paddingTop: '56.25%' // 16:9
    },
    cardMediaImage: {
      width: '100%',
      paddingTop: '100%'
    },
    cardContent: {
      flexGrow: 1
    },
    footer: {
      backgroundColor: palette.background.paper,
      padding: spacing(6)
    },
    horizontalBox: {
      display: 'flex',
      flexDirection: 'row'
    },
    paper: {
      padding: '10px'
    },
    noTextDecoration: {
      textDecoration: 'none'
    },
    clickPointer: {
      cursor: 'pointer'
    },
    iconWithText: {
      display: 'inline-flex',
      verticalAlign: 'top'
    }
  }
})

export default useStyles
